import Model from './Model';
import moment from 'moment';

export default class Voucher extends Model {
  initializeFields() {
    this.Id = this.data.Id || null;

    this.Name = this.data.Name;
    this.CouponCode = this.data.CouponCode;
    this.DiscountValue = this.data.DiscountValue;
    this.DiscountType = this.data.DiscountType;
    this.MinimumOrderValue = this.data.MinimumOrderValue;
    this.MaximumDiscountAmount = this.data.MaximumDiscountAmount;
    this.MinimumQuantity = this.data.MinimumQuantity;
    this.MaximumUsageCountPerCustomer = this.data.MaximumUsageCountPerCustomer;
    this.ApplicableOrderSource = this.data.ApplicableOrderSource;
    this.StartDate = this.data.StartDate;
    this.EndDate = this.data.EndDate;

    this.IsVoucherActivated = 1; // must be 1
    this.IsStandardOffer = 0; // must be 0

    this.Customers = this.prepareArrays('Customers');
    this.Products = this.prepareArrays('Products');
  }

  get duration() {
    const startDate = this.StartDate
      ? moment(this.StartDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : 'No start date';

    const endDate = this.EndDate
      ? moment(this.EndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : 'No end date';

    return `${startDate} - ${endDate}`;
  }

  prepareArrays(field) {
    if (!this.data[field]) {
      return [];
    }

    if (typeof this.data[field] === 'string') {
      try {
        return JSON.parse(this.data[field]);
      } catch {
        return this.data[field];
      }
    }

    return this.data[field];
  }
}
